<script setup lang="ts">
defineEmits<{ navigate: [] }>()
const { t } = useI18n()
</script>
<template><div class="legal"><span>© {{ new Date().getFullYear() }} MusicMint</span><span class="cluster"><a href="/privacy.html" target="_blank" rel="noopener" @click="$emit('navigate')">{{ t('mm.shell.privacy') }}</a><a href="/terms.html" target="_blank" rel="noopener" @click="$emit('navigate')">{{ t('mm.shell.terms') }}</a><a href="/data-deletion.html" target="_blank" rel="noopener" @click="$emit('navigate')">{{ t('t24a.dataDeletion') }}</a></span></div></template>
<style scoped>.legal .cluster { gap: 20px; }</style>
